<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 mb-base">
        <h2>{{$t('Exception Discounts')}}</h2>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'growth-hacker'" class="vx-col w-full lg:w-1/2 items-end">
        <div class="flex justify-between">
          <span class="font-semibold"></span>
          <span class="font-medium text-primary cursor-pointer">
            <vs-button
              @click="newExceptionDiscount()"
              color="primary"
              icon-pack="feather"
              icon="icon-plus"
              size="large"
            >
            </vs-button>
          </span>
        </div>
      </div>
    </div>
    <promo-exception-table :promoLoading="promoLoading" @type="type = $event" @codeData="exceptionDiscount = $event" @promoAndExceptionModal="exceptionDiscountModal = $event" :currentPage="currentPage" @currentPage="currentPage = $event" :totalRows="totalRows" :data="exceptionDiscounts"></promo-exception-table>
    <add-promo-code :type="type" :promoAndExceptionModal="exceptionDiscountModal" @promoAndExceptionModal="exceptionDiscountModal = $event" :data="exceptionDiscount" @loadData="loadExceptionDiscounts"></add-promo-code>
  </div>
</template>

<script>
import PromoExceptionTable from './components/PromoAndExceptionTable.vue'
import AddPromoCode from './components/AddPromoCode.vue'
import { sendRequest }  from '../../http/axios/requestHelper.js'

export default {
  data () {
    return {
      type: '',
      promoLoading: false,
      exceptionDiscounts: [],
      exceptionDiscount: {
        value: 0,
        limits: {
          expiry_date: '',
          per_merchant_cash_value: '',
          per_merchant_usage_count: '',
          start_date: '',
          total_cash_value: '',
          total_usage_count: ''
        },
        qualifier: {
          merchants: [],
          destination_governorates: [],
          package_sizes: [],
          service_levels: [],
          service_types: [],
          subscriptions: []
        },
        threshold: {
          count: 0,
          time_window: ''
        }
      },
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      selected: [],
      offset: 0,
      totalRows: 0,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      exceptionDiscountModal: false
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadExceptionDiscounts()
    }
  },
  methods: {
    loadExceptionDiscounts () {
      this.promoLoading = true
      sendRequest(true, false, this, `api/v1/discounts/exception-codes/?offset=${this.offset}&limit=${this.maximumItems}`, 'get', null, true,
        (response) => {
          this.exceptionDiscounts = response.data.results
          this.totalRows = response.data.count
          this.promoLoading = false
        }
      )
    },
    newExceptionDiscount () {
      this.exceptionDiscountModal = true
      this.type = 'Add'
      this.exceptionDiscount = {
        value: 0,
        limits: {
          expiry_date: '',
          per_merchant_cash_value: '',
          per_merchant_usage_count: '',
          start_date: '',
          total_cash_value: '',
          total_usage_count: ''
        },
        qualifier: {
          merchants: [],
          destination_governorates: [],
          package_sizes: [],
          service_levels: [],
          service_types: [],
          subscriptions: []
        },
        threshold: {
          count: 0,
          time_window: ''
        }
      }
    }
  },
  components: {
    AddPromoCode,
    PromoExceptionTable
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadExceptionDiscounts()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
</style>

<style lang="scss">
.con-pagination-table{
  display: none;
}
</style>